import React from 'react';
import moment from 'moment';
import { ordinalSuffix } from '../../../helpers/NumberFormatter';

class NextRun extends React.Component {
    getNextRunDate() {
        const { 
            period = 'daily', 
            date: startDate, 
            skipWeekend = false 
        } = this.props;

        if (!startDate) return null;
        const today = moment().startOf('day');
        let next = null;
        switch(period) {
            case 'one_time': {
                next = moment(startDate);
                if (next.isSameOrBefore(today)) return null;
                break;
            }
            case 'daily': {
                next = today.clone().add(1, 'day');
                break;
            }
            case 'weekly': {
                const target = moment(startDate).day();
                next = today.clone().day(target);
                if (next.isSameOrBefore(today)) next.add(7, 'days');
                break;
            }
            case 'bi_weekly': {
                const anchor = moment(startDate).startOf('day');
                const target = anchor.day();
                next = today.clone().day(target);
                if (next.isSameOrBefore(today)) next.add(7, 'days');
                while (next.diff(anchor, 'days') % 14 !== 0) {
                    next.add(7, 'days');
                }
                break;
            }
            case 'monthly_day': {
                const dayOfMonth = moment(startDate).date();
                next = today.clone().date(dayOfMonth);
                if (next.isSameOrBefore(today)) {
                    next.add(1, 'month').date(dayOfMonth);
                }
                break;
            }
            case 'monthly_day_of_week': {
                const dayOfWeek = moment(startDate).day();
                const weekOfMonth = Math.ceil(moment(startDate).date() / 7);

                const findOccurrence = (monthMoment) => {
                    const first = monthMoment.clone().startOf('month').day(dayOfWeek);
                    if (first.month() !== monthMoment.month()) first.add(7, 'days');
                    return first.clone().add((weekOfMonth - 1) * 7, 'days');
                };

                next = findOccurrence(today);
                if (next.isSameOrBefore(today)) {
                    next = findOccurrence(today.clone().add(1, 'month'));
                }
                break;
            }
            default:
                return null;
        }

        if (next && skipWeekend) {
            const day = next.day();
            if (day === 6) next.add(2, 'days');
            if (day === 0) next.add(1, 'day');
        }

        return next;
    }

    render() {
        const nextRun = this.getNextRunDate();
        if (!nextRun) return null;

        return (
            <React.Fragment>
                <span className="global-filter-preview-item-title">Next run: </span>
                <span className="global-filter-preview-item-value">
                    {nextRun.format('YYYY-MM-DD')}
                </span>
            </React.Fragment>
        );
    }
}

export default NextRun;